module.exports = __webpack_public_path__ + "static/media/bazdidemoon.056cb189.svg";